const TTL = {
  EMBASSY: 24 * 60 * 60 * 1000,
  STRUCTURE: 7 * 24 * 60 * 60 * 1000,
  CARD: 24 * 60 * 60 * 1000,
  PERSONALITY: 24 * 60 * 60 * 1000,
  SECTOR: 7 * 24 * 60 * 60 * 1000,
  SEARCH: 30 * 60 * 1000,
};

function setItem(key, value, ttl) {
  try {
    const record = {
      v: value,
      t: Date.now(),
      x: ttl || 0,
    };
    sessionStorage.setItem(key, JSON.stringify(record));
  } catch {
    // silent - quota exceeded or unavailable
  }
}

function getItem(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;

    const record = JSON.parse(raw);
    if (record.x && Date.now() - record.t > record.x) {
      sessionStorage.removeItem(key);
      return null;
    }
    return record.v;
  } catch {
    sessionStorage.removeItem(key);
    return null;
  }
}

function removeItem(key) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // silent
  }
}

function clearExpired() {
  try {
    const keys = Object.keys(sessionStorage);
    for (const key of keys) {
      getItem(key);
    }
  } catch {
    // silent
  }
}

function clearAll(prefix) {
  try {
    if (!prefix) {
      sessionStorage.clear();
      return;
    }
    const keys = Object.keys(sessionStorage);
    for (const key of keys) {
      if (key.startsWith(prefix)) {
        sessionStorage.removeItem(key);
      }
    }
  } catch {
    // silent
  }
}

export const SecureStorage = {
  setItem,
  getItem,
  removeItem,
  clearExpired,
  clearAll,
  TTL,
};
